export const uppercaseFirstLetter = (str:string) => {
    return str.length > 0 ? str.slice(0,1).toUpperCase() + str.slice(1, str.length) : '';
};